export const SUBSCRIPTION_PLANS = {
    FREE: 'free',
    PREMIUM: 'premium',
}
